(() => {
  function init() {
    document.querySelectorAll('[data-mobile-detail]').forEach(detail => {
      if (detail.dataset.ready) return;
      detail.dataset.ready = 'true';
      const narrow = matchMedia('(max-width: 760px)');
      const positionDetail = () => { detail.open = !narrow.matches; };
      positionDetail();
      narrow.addEventListener('change', positionDetail);
      const revealAnchor = () => {
        const target = document.getElementById(location.hash.slice(1));
        if (target && detail.contains(target)) detail.open = true;
      };
      window.addEventListener('hashchange', revealAnchor);
      revealAnchor();
    });
    document.querySelectorAll('[data-refill-options], [data-starter-options]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const radios = [...group.querySelectorAll('.purchase-radio')];
      const layout = group.closest('.purchase-layout');
      const gallery = layout?.querySelector('[data-gallery]');
      const mobileBar = layout?.querySelector('[data-mobile-purchase]');
      const mobileAdd = mobileBar?.querySelector('[data-mobile-add]');
      // Keep every mobile format visible before the selected offer details.
      // Move existing form nodes; never clone inputs, variants or selling plans.
      const mobile = matchMedia('(max-width: 760px)');
      const panels = radios.map(radio => ({choice:radio.closest('.purchase-choice'),panel:document.getElementById(radio.getAttribute('aria-controls'))}));
      const details = document.createElement('div');
      details.className = 'mobile-offer-details';
      group.append(details);
      function positionDetails() {
        panels.forEach(({choice,panel}) => {if(panel)(mobile.matches ? details : choice).append(panel);});
        details.hidden = !mobile.matches;
        group.classList.toggle('mobile-offers-condensed',mobile.matches);
      }
      positionDetails();
      mobile.addEventListener('change',positionDetails);
      const plainText = el => el ? [...el.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent).join('').trim() : '';
      function selectedPurchase() {
        const radio = radios.find(input => input.checked);
        const choice = radio?.closest('.purchase-choice');
        const panel = radio && document.getElementById(radio.getAttribute('aria-controls'));
        return {radio, choice, submit: panel?.querySelector('button[type="submit"]'), form: panel?.querySelector('form')};
      }
      // Show a purchase shortcut only after the complete choice/CTA area is past.
      // It must not duplicate the controls while customers are choosing an offer.
      function positionMobileBar() {
        if (mobileBar) mobileBar.hidden = !mobile.matches || group.getBoundingClientRect().bottom > 0;
      }
      let barFrame = 0;
      function scheduleMobileBar() {
        if (barFrame) return;
        barFrame = requestAnimationFrame(() => { barFrame = 0; positionMobileBar(); });
      }
      if (mobileBar) {
        window.addEventListener('scroll', scheduleMobileBar, {passive:true});
        window.addEventListener('resize', scheduleMobileBar, {passive:true});
        mobile.addEventListener('change', scheduleMobileBar);
        new ResizeObserver(scheduleMobileBar).observe(group);
      }
      function syncMobile() {
        if (!mobileBar) return;
        const {radio, choice, submit} = selectedPurchase();
        if (!choice) { mobileBar.hidden = true; return; }
        const name = plainText(choice.querySelector('.purchase-choice-name'));
        const price = plainText(choice.querySelector('.purchase-choice-price'));
        const period = choice.querySelector('.purchase-choice-price > span')?.textContent.trim() || '';
        mobileBar.querySelector('[data-mobile-name]').textContent = name;
        mobileBar.querySelector('[data-mobile-price]').textContent = `${price} ${period}`;
        const busy = submit?.textContent.includes('Adding to cart');
        mobileAdd.disabled = !submit || submit.disabled;
        mobileAdd.textContent = busy ? 'Adding…' : mobileAdd.disabled ? 'Not yet available' : 'Add to cart';
        mobileAdd.setAttribute('aria-label', `Add ${name} to cart`);
        const termsLine = mobileBar.querySelector('[data-mobile-terms]');
        termsLine.textContent = radio.value === 'starter-subscription'
          ? 'Then $29/month from day 60 · Auto-renews'
          : radio.value === 'refill-subscription' ? 'Auto-renews monthly' : '';
        termsLine.hidden = !termsLine.textContent;
        positionMobileBar();
      }
      layout?.querySelectorAll('a[href="#achat"]').forEach(link => link.addEventListener('click', event => {
        if (!mobile.matches) return;
        event.preventDefault();
        group.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      mobileAdd?.addEventListener('click', () => {
        const {submit, form} = selectedPurchase();
        if (!submit || submit.disabled || !form) return;
        // Submit the original form, preserving the exact variant and selling plan.
        form.requestSubmit(submit);
      });
      if (mobileBar) new MutationObserver(syncMobile).observe(group, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled']});
      function select() {
        radios.forEach(radio => {
          const panel = document.getElementById(radio.getAttribute('aria-controls'));
          if (panel) panel.hidden = !radio.checked;
        });
        syncMobile();
        if (group.hasAttribute('data-starter-options')) {
          const selectedStarter = radios.find(radio => radio.checked)?.value;
          const autoRefill = selectedStarter === 'starter-subscription';
          const systemCaption = gallery?.querySelectorAll('[data-gallery-panel]')[1]?.querySelector('figcaption');
          if (systemCaption) systemCaption.textContent = autoRefill
            ? 'Your jar now. First refill after 60 days, then monthly.'
            : 'The jar and refill system. Refills sold separately.';
          gallery?.querySelector(`[data-gallery-button="${autoRefill ? 1 : 0}"]`)?.click();
          return;
        }
        const selected = radios.find(radio => radio.checked);
        const quantity = selected?.value === 'refill-bundle-6' ? 6 : selected?.value === 'refill-bundle-3' ? 3 : 1;
        gallery?.querySelectorAll('[data-refill-packshot]').forEach(visual => {
          visual.dataset.quantity = String(quantity);
          visual.setAttribute('aria-label', `${quantity} AEVA creatine refill ${quantity === 1 ? 'pouch' : 'pouches'}, ${quantity * 150} g total`);
        });
        const story = layout?.closest('.refill-page')?.querySelector('[data-refill-story]');
        if (story) {
          const visual = story.querySelector('[data-refill-story-quantity]');
          visual.dataset.quantity = String(quantity);
          visual.setAttribute('aria-label', `${quantity} AEVA creatine refill ${quantity === 1 ? 'pouch' : 'pouches'}`);
          story.querySelector('[data-refill-story-contents]').textContent = `${quantity} ${quantity === 1 ? 'pouch' : 'pouches'} · ${quantity * 150} g · ${quantity * 30} servings`;
          story.querySelector('[data-refill-story-delivery]').textContent = selected?.value === 'refill-subscription'
            ? 'One pouch each month. Renews automatically.'
            : quantity === 1 ? 'One pouch. One-time purchase.' : 'All pouches delivered together. No subscription.';
        }
        const caption = gallery?.querySelector('[data-refill-caption]');
        if (caption) caption.textContent = `${quantity} × 150 g · ${quantity * 30} daily servings. Jar not included.`;
        const thumbnailLabel = gallery?.querySelector('[data-refill-thumbnail-label]');
        if (thumbnailLabel) thumbnailLabel.textContent = quantity === 1 ? 'The pouch' : `${quantity} pouches`;
        // Return to the selected format after browsing detail photographs.
        gallery?.querySelector('[data-gallery-button="0"]')?.click();
        const weight = layout?.querySelector('[data-refill-weight]');
        const servings = layout?.querySelector('[data-refill-servings]');
        const format = layout?.querySelector('[data-refill-format]');
        if (weight) weight.textContent = `${quantity * 150} g`;
        if (servings) servings.textContent = `${quantity * 30} × 5 g`;
        if (format) format.textContent = quantity === 1 ? 'Pouch only' : `${quantity} pouches`;
      }
      function fromHash() {
        const matching = radios.find(radio => '#' + radio.value === location.hash);
        if (matching) matching.checked = true;
        select();
        if (matching) requestAnimationFrame(() => matching.closest('.purchase-choice')?.scrollIntoView({block:'start'}));
      }
      group.querySelectorAll('[data-continue-starter]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        const once = radios.find(radio => radio.value === 'starter-one-off');
        if (!once) return;
        once.checked = true; select();
        history.replaceState(null, '', '#starter-one-off');
        document.getElementById(once.getAttribute('aria-controls'))?.querySelector('form')?.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }));
      radios.forEach(radio => radio.addEventListener('change', select));
      window.addEventListener('hashchange', fromHash);
      fromHash();
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
